import CategoryOptionLabel from '@app/src/components/CategoryOptionLabel'
import { useAutomationDisplayData } from '@app/src/hooks/useAutomationSummary'
import { RequestAutomationType } from '@app/src/pages/Configurations/ConfigurationsPages/Automation/RequestAutomationType'
import type { RequestAutomation } from '@app/src/types/automations'
import { Skeleton, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

interface AutomationDisplaySectionProps {
  automation: RequestAutomation
}

const AutomationDisplaySection: React.FC<AutomationDisplaySectionProps> = ({ automation }) => {
  const { formatMessage } = useIntl()
  const {
    automationType,
    summaryLabel,
    additionalCategoryCount,
    additionalCategoriesTooltipLabels,
    categoryOptionsFilterValue,
    isCategoryLabelsLoading,
  } = useAutomationDisplayData(automation)

  if (isCategoryLabelsLoading) {
    return <Skeleton width={70} variant="rounded" />
  }

  if (automationType === RequestAutomationType.FOR_PROVIDERS_IN_CATEGORY) {
    return (
      <>
        <Typography variant="body1" fontWeight="bold" textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">
          {summaryLabel}
        </Typography>

        {additionalCategoryCount > 0 && (
          <Tooltip
            title={
              <>
                {additionalCategoriesTooltipLabels.map((label, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && '; '}
                    {label}
                  </React.Fragment>
                ))}

                {Boolean(additionalCategoriesTooltipLabels.length) &&
                  Boolean(categoryOptionsFilterValue.length) &&
                  '; '}

                {categoryOptionsFilterValue.map((v, i) => (
                  <React.Fragment key={v}>
                    <CategoryOptionLabel
                      categoryOptionId={v}
                      categoryCount={categoryOptionsFilterValue.length}
                      isLastItem={i === categoryOptionsFilterValue.length - 1}
                    />
                  </React.Fragment>
                ))}
              </>
            }
          >
            <Typography variant="body1" ml={1} whiteSpace="nowrap">
              {formatMessage({ id: 'automatedSendout.plusMore' }, { count: additionalCategoryCount })}
            </Typography>
          </Tooltip>
        )}
      </>
    )
  }

  return (
    <Typography variant="body1" fontWeight="bold" whiteSpace="pre-line">
      {summaryLabel}
    </Typography>
  )
}

export default AutomationDisplaySection
